<template>
  <div>
    <Galeria v-model="oportunidade.galeria_arquivo" />
  </div>
</template>

<script>
import Galeria from "@/modules/files/Components/Galeria.vue";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { mapState } from "vuex";

export default {
  components: { Galeria },
  mixins: [validationMixin],
  validations: {
    oportunidade: {},
  },
  computed: {
    ...mapState("oportunidades", ["oportunidade"]),
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.oportunidade[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.oportunidade.$touch();
      return !this.$v.oportunidade.$anyError;
    },
  },
};
</script>

<style>
</style>
